/* eslint-disable max-len */
import * as React from 'react';

export const AIIcon = React.memo(({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.667969 8.00003C0.667969 8.42859 0.943689 8.80963 1.35142 8.94222L5.66051 10.3426L7.05971 14.6496C7.19171 15.0573 7.57304 15.3337 8.0013 15.3337C8.42957 15.3337 8.81089 15.0576 8.94289 14.6496L10.345 10.3426L14.6512 8.94222C15.0589 8.80963 15.3346 8.42888 15.3346 8.00033C15.3346 7.57147 15.0589 7.19102 14.6512 7.05843L10.345 5.65806L8.94289 1.35105C8.81089 0.943019 8.42957 0.666992 8.0013 0.666992C7.57304 0.666992 7.19171 0.943312 7.05971 1.35105L5.66051 5.65806L1.35142 7.05843C0.943689 7.19102 0.667969 7.57118 0.667969 8.00003Z"
      fill={color || 'url(#paint0_linear_30145_237881)'}
    />
    <defs>
      <linearGradient
        id="paint0_linear_30145_237881"
        x1="4.5"
        y1="4.00024"
        x2="16"
        y2="17.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color || '#6340FF'} />
        <stop offset="0.341246" stopColor={color || '#A69FFF'} />
        <stop offset="0.648248" stopColor={color || '#EF4BFE'} />
        <stop offset="1" stopColor={color || '#87ABFF'} />
      </linearGradient>
    </defs>
  </svg>
));
